import React, { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';
import { IconWrapper } from './IconWrapper';

interface FeatureCardProps {
  title: string;
  description: string;
  icon?: ReactNode;
  iconComponent?: LucideIcon;
  variant?: 'light' | 'dark';
  className?: string;
  industries?: string[];
}

export const FeatureCard: React.FC<FeatureCardProps> = ({
  title,
  description,
  icon,
  iconComponent: Icon,
  variant = 'light',
  className = '',
  industries,
}) => {
  const bgColor = 'bg-white';
  const borderColor = 'border-gray-200';
  const titleColor = 'text-dark-900';
  const descriptionColor = 'text-dark-700';
  const iconColor = 'text-blue-700';

  return (
    <div
      className={`feature_card p-6 sm:p-8 rounded-xl border ${borderColor} ${bgColor} shadow-sm hover:shadow-md transition-all duration-300 ${className}`}
    >
      <div className="flex items-center gap-3 mb-4">
        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-blue-100">
          {icon ? (
            icon
          ) : Icon ? (
            <Icon className={`h-5 w-5 ${iconColor}`} />
          ) : null}
        </div>
        <h3 className={`heading-style-h3 text-lg sm:text-xl font-normal text-dark-900 mb-0`}>{title}</h3>
      </div>
      <p className={`text-base text-dark-700 font-normal mb-4 leading-relaxed`}>{description}</p>
      {industries && industries.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-2">
          {industries.map((industry) => (
            <span
              key={industry}
              className="bg-blue-100 text-blue-700 rounded-full px-3 py-1 text-xs font-['Source Sans Pro'] font-semibold"
            >
              {industry}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};
